import { useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSearch,
  faChevronRight,

  faArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { commonAPI } from "../../../services/CommonAPIService";
import { RoleIcons } from "../../../assets/img/roles";
import CrossIcon from "../../../assets/icons/maid-module-icons/CrossIcon.svg"

const AddStaffModal = ({ show, onClose, onRoleSelected }) => {
  const [departments, setDepartments] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDepartment, setSelectedDepartment] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");


const fetchData = async () => {
  const auth = localStorage.getItem("userData");
  if (!auth) return;

  const myUserData = JSON.parse(auth);

  setLoading(true);
  setError(null);
  setSelectedDepartment(null);
  setSearchTerm("");

  try {
    const response = await commonAPI("Department", undefined, {
      buildingId: myUserData?.buildingId,
    });

    if (response?.success === true) {
      console.log("mobile number is",myUserData?.mobileNumber);
      setDepartments(response.data || []);
    } else {
      setError(response?.message || "Failed to load departments");
    }
  } catch (err) {
    console.error("Fetch departments error:", err);

    const bodyError = {
      userId: myUserData?.userId,
      mobileNumber: myUserData?.mobileNumber,
      requestJSON: null,
      uri: "/api/Master/Department",
      errorSource: "CuroNextPortal",
      errorNumber: "ADSTF01",
      errorSummary: err?.message,
      errorDescription: err?.message,
      fileClassName: "AddStaffModal.js",
      functionName: "fetchData",
    };

    try {
      await commonAPI("ErrorLogMaster", bodyError);
    } catch (logErr) {
      console.error("Error while logging error:", logErr);
    }

    setError("Error loading departments and roles");
  } finally {
    setLoading(false);
  }
};

  useEffect(() => {
    if (show) {
      fetchData();
    }
  }, [show]);

  if (!show) return null;

  const lowerSearch = searchTerm.toLowerCase().trim();
  const hasSearch = lowerSearch.length > 0;

  // All roles with department reference
  const allRolesWithDept = departments.flatMap(dept =>
    (dept.roles || []).map(role => ({
      ...role,
      departmentName: dept.departmentName,
      departmentId: dept.departmentId,
    }))
  );

  // Filtered roles (global)
  const matchingRoles = hasSearch
    ? allRolesWithDept.filter(role =>
        role.roleName?.toLowerCase().includes(lowerSearch)
      )
    : [];

  // Filtered departments
  const filteredDepartments = hasSearch
    ? departments.filter(dept =>
        dept.departmentName?.toLowerCase().includes(lowerSearch)
      )
    : departments;

  // Frequent roles
  const frequentRoles = departments
    .flatMap(dept => dept.roles || [])
    .filter(role => role.isFrequent === true);

  const filteredFrequentRoles = lowerSearch
    ? frequentRoles.filter(role =>
        role.roleName?.toLowerCase().includes(lowerSearch)
      )
    : frequentRoles.slice(0, 8);

  // Selected department roles
  const selectedDeptRoles = selectedDepartment
    ? departments.find(d => d.departmentId === selectedDepartment.departmentId)?.roles || []
    : [];

  const filteredDeptRoles = lowerSearch
    ? selectedDeptRoles.filter(role =>
        role.roleName?.toLowerCase().includes(lowerSearch)
      )
    : selectedDeptRoles;

  const handleRoleClick = (role) => {
    if (onRoleSelected) {
      onRoleSelected(role);
    }
    onClose();
  };

  return (
    <>
      <div className="modal fade show" style={{ display: "block", zIndex: 1055 }} tabIndex="-1">
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content rounded-3 shadow border-0">
            <div className="modal-header text-white border-0 px-4 py-3" style={{ background: "#1C80D2" }}>
              <h5 className="modal-title fw-bold fs-5">
                {selectedDepartment ? selectedDepartment.departmentName : "Add Staff"}
              </h5>
                  <button
              className="btn p-0 d-flex align-items-center justify-content-center bg-white"
              style={{ width: 24, height: 24, borderRadius: 6 }}
              onClick={onClose}
            >
              <img src={CrossIcon} alt="cross" />
            </button>
            </div>

            <div className="modal-body p-4 bg-white" style={{ maxHeight: "75vh", overflowY: "auto" }}>
              <div className="input-group mb-4 shadow-sm rounded-pill overflow-hidden">
                <span className="input-group-text bg-white border-0 ps-4 pe-2">
                  <FontAwesomeIcon icon={faSearch} className="text-muted" />
                </span>
                <input
                  type="text" 
                  className="form-control border-0 py-3 fs-6"
                  placeholder="Search Categories or Roles"
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                />
              </div>

              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status" />
                </div>
              ) : error ? (
                <div className="alert alert-danger text-center">{error}</div>
              ) : (
                <>
                  {/* Frequently Used - only when no search and no department selected */}
                  {!selectedDepartment && !hasSearch && filteredFrequentRoles.length > 0 && (
                    <>
                      <h6
                        className="mb-3"
                        style={{
                          color: "#000000",
                          fontSize: "1.1rem",
                          fontWeight: "700"
                        }}
                      >
                        Frequently Used
                      </h6>

                      <div className="row g-3 mb-5">
                        {filteredFrequentRoles.map((role, idx) => (
                          <div key={idx} className="col-6 col-sm-4 col-md-3">
                            <div
                              className="card border-0 shadow-sm text-center py-3 h-100"
                              style={{ cursor: "pointer", borderRadius: "12px",background:"#F6F6F6" }}
                              onClick={() => handleRoleClick(role)}
                            >
                              <img
                                src={RoleIcons[role.imageIconURL] || RoleIcons.default}
                                alt={role.roleName}
                                style={{ width: "48px", height: "48px", margin: "0 auto 12px", objectFit: "contain" }}
                              />
                              <div className="small fw-medium">{role.roleName}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}

                  {/* Back button + section title */}
                  <div className="d-flex align-items-center mb-3">
                    {selectedDepartment && (
                      <button
                        className="btn btn-link text-muted p-0 me-3"
                        onClick={() => {
                          setSelectedDepartment(null);
                          setSearchTerm("");
                        }}
                        style={{ fontSize: "1.1rem" }}
                      >
                        <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                        Back
                      </button>
                    )}
                    <h6
                        className="m-0"
                        style={{
                          color: "#000000",
                          fontSize: "1.5rem",
                          fontWeight: "700"
                        }}
                      >
                        {selectedDepartment
                          ? "Roles"
                          : hasSearch
                          ? "Search Results"
                          : " All Categories"}
                      </h6>

                  </div>

                  {/* Content based on state */}
                  {selectedDepartment ? (
                    /* Selected Department View */
                    filteredDeptRoles.length > 0 ? (
                      <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm">
                        {filteredDeptRoles.map((role, idx) => (
                          <button
                            key={idx}
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                            onClick={() => handleRoleClick(role)}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={RoleIcons[role.imageIconURL] || RoleIcons.default}
                                alt={role.roleName}
                                style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                              />
                              <span className="fw-medium">{role.roleName}</span>
                            </div>
                            <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div className="alert alert-info text-center m-3">No roles found</div>
                    )
                  ) : hasSearch ? (
                    /* Global Search Results */
                    <>
                      {/* Matching Roles */}
                      {matchingRoles.length > 0 && (
                        <>
                          <h6 className="fw-bold text-uppercase text-muted small mb-3">Roles</h6>
                          <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm mb-4">
                            {matchingRoles.map((role, idx) => (
                              <button
                                key={`role-${idx}`}
                                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                                onClick={() => handleRoleClick(role)}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    src={RoleIcons[role.imageIconURL] || RoleIcons.default}
                                    alt={role.roleName}
                                    style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                                  />
                                  <div>
                                    <div className="fw-medium">{role.roleName}</div>
                                    <small className="text-muted">{role.departmentName}</small>
                                  </div>
                                </div>
                                <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                              </button>
                            ))}
                          </div>
                        </>
                      )}

                      {/* Matching Departments */}
                      {filteredDepartments.length > 0 && (
                        <>
                          <h6 className="fw-bold text-uppercase text-muted small mb-3">Categories</h6>
                          <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm">
                            {filteredDepartments.map((dept, idx) => (
                              <button
                                key={`dept-${idx}`}
                                className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                                onClick={() => setSelectedDepartment(dept)}
                              >
                                <div className="d-flex align-items-center">
                                  <img
                                    src={RoleIcons[dept.imageIconURLDept] || RoleIcons.default}
                                    alt={dept.departmentName}
                                    style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                                  />
                                  <span className="fw-medium">{dept.departmentName}</span>
                                </div>
                                <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                              </button>
                            ))}
                          </div>
                        </>
                      )}

                      {matchingRoles.length === 0 && filteredDepartments.length === 0 && (
                        <div className="alert alert-info text-center m-3">
                          No matching roles or categories found
                        </div>
                      )}
                    </>
                  ) : (
                    /* Default Departments List */
                    filteredDepartments.length > 0 ? (
                      <div className="list-group border-0 rounded-3 overflow-hidden shadow-sm">
                        {filteredDepartments.map((dept, idx) => (
                          <button
                            key={idx}
                            className="list-group-item list-group-item-action d-flex justify-content-between align-items-center py-3 px-4"
                            onClick={() => setSelectedDepartment(dept)}
                          >
                            <div className="d-flex align-items-center">
                              <img
                                src={RoleIcons[dept.imageIconURLDept] || RoleIcons.default}
                                alt={dept.departmentName}
                                style={{ width: "32px", height: "32px", marginRight: "16px", objectFit: "contain" }}
                              />
                              <span className="fw-medium">{dept.departmentName}</span>
                            </div>
                            <FontAwesomeIcon icon={faChevronRight} className="text-muted" />
                          </button>
                        ))}
                      </div>
                    ) : (
                      <div className="alert alert-info text-center m-3">No departments available</div>
                    )
                  )}
                </>
              )}
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show" style={{ zIndex: 1050 }} onClick={onClose} />
    </>
  );
};

export default AddStaffModal;